import { render, staticRenderFns } from "./CreateExaminationModal.vue?vue&type=template&id=0ca9eb71"
import script from "./CreateExaminationModal.vue?vue&type=script&lang=js"
export * from "./CreateExaminationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports